import { useMutation } from "@tanstack/react-query";
import { useAuthContext } from "@src/context/authContext";
import AppUtils from "@src/utils/appUtils";
import LoginForm from "@src/components/forms/LoginForm";
import { authEndpoints } from "@src/services/endpoints";
import { StorageUtils } from "@src/utils";

const LoginPage = (props) => {
  const { usernameType } = props;
  const { setUserTokens } = useAuthContext();

  const login = useMutation({
    mutationKey: ["LOGIN"],
    mutationFn: (creds) => authEndpoints.login(creds),
    onSuccess: (data) => {
      setUserTokens(data);
      // force reload to the desired location or the overview page by default
      const targetLocation = StorageUtils.getItem("targetLocation");
      if (!!targetLocation) {
        StorageUtils.removeItem("targetLocation");
        window.location.href = targetLocation;
      } else {
        window.location.href = "/dashboard";
      }
    },
  });

  return (
    <div className="bg-white rounded-2xl mx-8 md:mx-0 overflow-clip w-full max-w-md xl:max-w-lg">
      <div className="px-8">
        <LoginForm
          // https://tkdodo.eu/blog/mastering-mutations-in-react-query#mutate-or-mutateasync
          onLoginSubmit={login.mutateAsync}
          validationMode={"onChange"}
          usernameType={usernameType}
          {...props}
        />
      </div>
      <div className="flex justify-end bg-primary-300 text-white">
        <a
          href="mailto:support@signol.io?Subject=Support"
          className="my-4 mx-8 font-bold underline cursor-pointer"
        >
          Support
        </a>
      </div>
    </div>
  );
};

export const loginPageControls = {};

LoginPage.propTypes = AppUtils.getPropTypeFromControls(loginPageControls);

export default LoginPage;
